import { ApiKey, HttpClient } from 'shared/libs/http';
import {
   TransactionActionResponse,
   TransactionsIndexRequest,
   TransactionsIndexResponse,
   UpdateTransactionStatusRequest,
   UpdateTransactionStatusResponse,
} from './types';

type AdminRequestOptions = {
   adminID?: string;
   tokenKey?: string;
};

const adminHeaders = ({ adminID, tokenKey }: AdminRequestOptions) => ({
   key: ApiKey,
   adminid: adminID,
   Authorization: `Bearer ${tokenKey}`,
});

export class TransactionsApiService {
   public static async loadTransactions(
      data: TransactionsIndexRequest,
      opt: AdminRequestOptions = {}
   ) {
      return await HttpClient.post<TransactionsIndexResponse>('/admin/payment/index', data, {
         headers: adminHeaders(opt),
      });
   }

   public static async activateTransaction(id: number, opt: AdminRequestOptions = {}) {
      return await HttpClient.post<TransactionActionResponse>(
         '/plans/activate',
         { id },
         {
            headers: {
               ...adminHeaders(opt),
               token: opt.tokenKey,
               'Content-Type': 'application/json',
            },
         }
      );
   }

   public static async deactivateTransaction(id: number, opt: AdminRequestOptions = {}) {
      return await HttpClient.post<TransactionActionResponse>(
         '/plans/deactivate',
         { id },
         {
            headers: {
               ...adminHeaders(opt),
               token: opt.tokenKey,
               'Content-Type': 'application/json',
            },
         }
      );
   }

   public static async updateTransactionStatus(
      data: UpdateTransactionStatusRequest,
      opt: AdminRequestOptions = {}
   ) {
      return await HttpClient.post<UpdateTransactionStatusResponse>('/plans/status', data, {
         headers: {
            ...adminHeaders(opt),
            token: opt.tokenKey,
            'Content-Type': 'application/json',
         },
      });
   }

   public static async downloadTransactions(opt: AdminRequestOptions = {}) {
      return await HttpClient.get<Blob>('/admin/payment/generatexcel', {
         headers: adminHeaders(opt),
         responseType: 'blob',
      });
   }
}
